// hooks/useUpdateTransaction.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";

interface UpdatePayload {
  updatedValues: Record<string, any>;
  extTxnId: string;
  page: string;
}

export const useTxnUserValue = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ updatedValues, extTxnId }: UpdatePayload) => {
      const token = await getToken();
      return await authorizedAxios(token).put(
        `/transaction/${extTxnId}`,
        updatedValues
      );
    },

    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [`transaction/${variables.extTxnId}`],
      });

      queryClient.invalidateQueries({
        queryKey: [`audit-${variables.page}`],
      });
    },
  });

  return mutation;
};
